import React from 'react'
import Landpage from '../components/Landpage/Landpage'
import About from '../components/about/About'
import Feature from '../components/feature/Feature'
import Review from '../components/review/Review'
import Contact from '../components/contact-v2/Contact'
import Footer from '../components/footer/Footer'
import Demo from "../components/demo/Demo"
import FlareNetwork from '../components/flare-network/FlareNetwork'
import HowItWorks from '../components/how-it-works/HowItWorks'
import Card from '../components/card/Card'
import CryptoPanicWidget from '../components/crypto-panic-widget'
import Faq from '../components/Faq/Faq'
const Home = () => {
  return (
    <main className='home-img'>
      <Landpage />
        <About />
        <Card />
        <FlareNetwork/>
        <Demo/>

        <HowItWorks/>
        <Faq />
        <Feature />
        <Contact />
        <Review />

        <CryptoPanicWidget />
    
        <Footer />
    </main>
  )
}

export default Home